export default "__VITE_ASSET__Cd7C9N1M__"